import React from "react";

import { Viewer } from "../../modules/viewer/Viewer";

export function ViewerPage() {
  return <Viewer />;
}
